import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LoadingButton } from 'components';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import { selectBundleGenerating } from 'services/store/bundles/selectors';

interface GenerateButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

const GenerateButton = ({ disabled, onClick }: GenerateButtonProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const isGenerating = useSelector(selectBundleGenerating);

  return (
    <LoadingButton
      loading={isGenerating}
      disabled={disabled}
      type="submit"
      variant="rounded"
      onClick={onClick}
      sx={{
        width: '100% !important',
        height: '100% !important',
        padding: theme.spacing(1, 3),
        textTransform: 'none',
        textDecoration: 'none',
      }}
    >
      {t(aiMusicGenerator.sideBar.generate.toUpperCase())}
    </LoadingButton>
  );
};

export default GenerateButton;
